/**
 * //////////////////////////////////
 * フォームテンプレー
 * /////////////////////////////////
 *
 * コンポーネントのフォームテンプレはここに書いています。
 * ＨＴＭＬフォームで未入力状態でフォーム送信を実行すればフォームの入力キーが無くなってしまうので、nullフィールドがあっても、
 * 必ずフォームテンプレを送信するようにここにファイルが必要です。
 */

const terminateForm = {
    cancel_prefferd_ym:null,
    cancel_reasons1: null,
    cancel_reason2: null,
    cancel_reason3: null,
}


export const forms = {
    terminateForm
}

export default forms
